/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { INosLinkListViewProps } from './nos-link-list';

const NosLinkListView: React.FC<INosLinkListViewProps> = props => {
    const config = props.config;

    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {config.linkList && <ul className={`${props.className}__list`}>{props.linkList}</ul>}
        </div>
    );
};

export default NosLinkListView;
